<template>
  <v-dialog v-model="dialog" max-width="620">
    <v-card>
      <v-card-title class="headline">¿Estás seguro de que quieres eliminar este registro?</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="green darken-1" text @click.prevent="deleteItem()">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: false,
    },
    apiURL: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    item: {},
    dialog: false,
  }),

  methods: {
    openModal(item) {
      this.dialog = true;
      this.item = item;
    },
    deleteItem() {
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url).then((response) => {
        this.$emit('update:message', response.data.message);
        this.$emit('update:type', response.data.type);
        this.dialog = false;
      });
    },
  },
};
</script>
